import { isString } from 'shared/utils/type-guards'
import { useCurrentUserContextOrganizationUpdatedSubscription } from '~/common/types/graphql'

export const useUpdatedSubscription = (organizationId?: string | null) => {
  return useCurrentUserContextOrganizationUpdatedSubscription({
    variables: { organizationId: organizationId ?? '' },
    skip: !isString(organizationId),
  })
}
